import footerContent from '@content/footer.yaml'
import type { FooterContent } from '@/types/content'

const content = footerContent as unknown as FooterContent

export function Footer() {
  return (
    <footer>
      <div>
        <div className="fw">{content.wordmark}<span className="dot">.</span></div>
        <p className="ft">{content.tagline}</p>
      </div>
      {content.columns.map(col => (
        <div key={col.title}>
          <p className="fcolt">{col.title}</p>
          <ul className="flinks">
            {col.links.map(link => (
              <li key={link.label}><a href={link.href}>{link.label}</a></li>
            ))}
          </ul>
        </div>
      ))}
      <div className="fbot">
        {content.bottom.map(text => (
          <span key={text} className="fcp">{text}</span>
        ))}
      </div>
    </footer>
  )
}
